/**
 * Single source of truth for the app's version number.
 *
 * VERSIONING RULES (bumped by the AI agent as it ships changes):
 *   • Bump the MAJOR number (+1.0) for BIG changes:
 *       - New top-level features (e.g. SMS notifications, new event type, auth overhaul)
 *       - Breaking API changes, schema migrations
 *       - Major UI redesigns / new pages
 *   • Bump the MINOR number (+0.1) for SMALL changes:
 *       - Bug fixes
 *       - Small UI polish (button styling, copy tweaks, new toggles)
 *       - Non-breaking refactors, internal cleanups
 *       - New data fields, small endpoint additions
 *
 * When both a big and small change land in one turn, prefer the bigger bump.
 * Do NOT bump for pure comment / whitespace edits.
 */
export const APP_VERSION = 'v10.4';
